export default "__VITE_ASSET___tpopMCI__"